<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="字典显示值">
              <a-input v-model="queryParam.name" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="字典值">
              <a-input v-model="queryParam.value" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="字典类型">
                <a-select
                  showSearch
                  :filterOption="filterOption"
                  v-model="queryParam.typeCode"
                  default-value="0"
                  placeholder="请选择"
                >
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in typeSelect"
                    :key="index"
                    :value="item.code"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
      <a-button
        type="dashed"
        v-if="config.hasAlert"
        @click="tableOption"
      >{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="namefy" slot-scope="text, record">
        <div style="width:140px; word-wrap:break-word">{{record.name}}</div>
      </span>
      <span slot="valuefy" slot-scope="text, record">
        <div style="width:120px; word-wrap:break-word">{{record.value}}</div>
      </span>
      <span slot="typeCodefy" slot-scope="text, record">
        <div style="width:140px; word-wrap:break-word">{{record.typeCode}}</div>
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="handleDel(record)">删除</a>
      </span>
    </s-table>

    <a-modal
      title="编辑"
      style="top: 20px;"
      :width="560"
      v-model="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
    >
      <a-form :form="form">
        <a-form-item label="字典类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            showSearch
            :filterOption="filterOption"
            v-model="mdl.typeCode"
            placeholder="请选择字典类型"
            v-decorator="['typeCode',
            { initialValue: mdl.typeCode, rules: [{ required: true, message: '请选择字典类型'}]}]"
          >
            <a-select-option
              v-for="(item, index) in typeSelect"
              :key="index"
              :value="item.code"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="字典编码" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
            <a-input
              v-model="mdl.code"
              placeholder="字典编码"
              v-decorator="['code',
              { initialValue: mdl.code, rules: [{ required: true, message: '请输入字典code'}]}]"
            />
          </a-form-item>
  
        <a-form-item label="字典值" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.value"
            placeholder="字典值"
            v-decorator="['value',
            { initialValue: mdl.value, rules: [{ required: true, message: '请输入字典Key'}]}]"
          />
        </a-form-item>

        <a-form-item label="字典显示值" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            v-model="mdl.name"
            placeholder="字典显示值"
            v-decorator="['name',
            { initialValue: mdl.name, rules: [{ required: true, message: '请输入字典值'}]}]"
          />
        </a-form-item>

        <a-form-item label="字典说明" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.remark" placeholder="字典说明" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import {
  menuPage,
  menuUpdate,
  menuSave,
  menuDelete,
  menuList,
  codePage,
  codeTypeList,
  codeUpdate,
  codeSave,
  codeDelete
} from '@/api/sys'

export default {
  pageSizeOptionsList:['10'],
  name: 'Privillege',
  components: {
    STable
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' }
          // width: '150px',
        },
        {
          title: '字典Key',
          // dataIndex: 'value',
          // width: '150px',
          scopedSlots: { customRender: 'valuefy' }
        },
        {
          title: '字典值',
          // dataIndex: 'name',
          // width: '150px',
          scopedSlots: { customRender: 'namefy' }
        },
        {
          title: '字典编码',
          dataIndex: 'code'
          // width: '150px',
        },
        {
          title: '字典类型',
          dataIndex: 'typeName'
          // width: '150px',
        },
        {
          title: '字典类型代码',
          // dataIndex: 'typeCode',
          // width: '150px',
          scopedSlots: { customRender: 'typeCodefy' }
        },
        {
          title: '操作',
          width: '130px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 所属菜单下拉
      typeSelect: null,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return codePage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created() {
    this.tableOption()
    this.loadSelect()
  },
  methods: {
    loadSelect() {
      // 从后台拉去下拉列表数据
      new Promise(resolve => {
        const data = codeTypeList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.typeSelect = res
      })
    },
    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit(record) {
      this.mdl = Object.assign({}, record)
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleAdd() {
      this.mdl = {}
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          if (this.mdl.id !== undefined) {
            codeUpdate(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(() => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          } else {
            codeSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(() => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    },
    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk() {
          return codeDelete({ ids: record.id })
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {})
        },
        onCancel() {}
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    }
  }
}
</script>
